import { Component } from 'react';
import styles from '../../styles/amcs.scss';
import { SubHeading } from '../common';

interface SectorItem {
  type: string;
  weightage: number;
}

interface HoldingItem {
  name: string;
  weighting: number;
}

interface HoldingsAndSectorsProps {
  sectors: SectorItem[];
  holdings: HoldingItem[];
  assetAllocation: any;
}

class HoldingsAndSectors extends Component<HoldingsAndSectorsProps, any> {
  constructor(props: HoldingsAndSectorsProps) {
    super(props);
    this.state = {
      selectedTab: 'holdings',
    };
  }

  public switchBtn = (tab: string) => {
    this.setState({ selectedTab: tab });
  };

  public tabSelector = () => {
    const { selectedTab } = this.state;
    return (
      <div className="lil-flex lil-justify-left">
        <div
          id="switchBtnHolder1"
          onClick={() => this.switchBtn('holdings')}
          className={`lil-w-1/5 lil-text-center lil-cursor-pointer lil-font-semibold lil-py-2 sm:lil-w-1/2
                                ${
                                  selectedTab === 'holdings'
                                    ? `lil-border-b-lg ${styles['border-blue-250']} lil-bg-blue-50 `
                                    : ' '
                                }`}
        >
          Top Holdings
        </div>
        <div
          id="switchBtnHolder2"
          onClick={() => this.switchBtn('sectors')}
          className={`lil-w-1/5 lil-text-center lil-cursor-pointer lil-font-semibold lil-py-2 sm:lil-w-1/2
                                ${
                                  selectedTab === 'sectors'
                                    ? `lil-border-b-lg ${styles['border-blue-250']} lil-bg-blue-50 `
                                    : ' '
                                }`}
        >
          Top Sectors
        </div>
      </div>
    );
  };

  private getTopSectors = (data: SectorItem[]): SectorItem[] => {
    return data
      .slice()
      .sort((a, b) => b.weightage - a.weightage)
      .slice(0, 5);
  };

  private getTopHoldings = (data: HoldingItem[]): HoldingItem[] => {
    return data
      .slice()
      .sort((a, b) => b.weighting - a.weighting)
      .slice(0, 5);
  };

  public renderTable = () => {
    const { sectors, holdings } = this.props;
    const { selectedTab } = this.state;
    const columns =
      selectedTab === 'holdings'
        ? [
            { title: 'Holding Name', key: 'name', className: 'lil-w-1/2' },
            {
              title: 'Assets (%)',
              key: 'weighting',
              className: 'lil-w-1/2 lil-text-right lil-font-semibold',
            },
          ]
        : [
            { title: 'Sector', key: 'type', className: 'lil-w-1/2' },
            {
              title: 'Category (%)',
              key: 'weightage',
              className: 'lil-w-1/2 lil-text-right lil-font-semibold',
            },
          ];
    const data =
      selectedTab === 'holdings'
        ? this.getTopHoldings(holdings)
        : this.getTopSectors(sectors);
    return (
      <div className="lil-mt-4 lil-w-full">
        <table
          className="lil-text-s-18 lil-border-separate lil-w-full"
          style={{ tableLayout: 'fixed' }}
        >
          <thead>
            <tr>
              {columns.map((col, index) => (
                <th
                  key={index}
                  className={`lil-border-none lil-text-left ${col.className}`}
                >
                  {col.title}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.map((item, rowIndex) => (
              <tr key={rowIndex} className="lil-relative">
                {columns.map((col, colIndex) => (
                  <td
                    key={colIndex}
                    className={`lil-border-none lil-font-light lil-py-4 ${col.className}`}
                  >
                    {col.key === 'weighting' || col.key === 'weightage'
                      ? `${item[col.key as keyof typeof item]}%`
                      : item[col.key as keyof typeof item]}
                  </td>
                ))}
                {rowIndex !== data.length - 1 && (
                  <div className="lil-absolute lil-h-px lil-bg-grey-300 lil-bottom-0 lil-left-0 lil-right-0"></div>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  };

  render() {
    return (
      <div className="lil-mt-0 lil-pt-12">
        <div className="sm:lil-px-6">
          {this.props.assetAllocation ? null : (
            <div className="lil-pb-4">
              <SubHeading title="Fund Distribution" />
            </div>
          )}
          {this.tabSelector()}
          {this.renderTable()}
        </div>
      </div>
    );
  }
}

export default HoldingsAndSectors;



// WEBPACK FOOTER //
// ./components/singleFundNewCmp/holdingsAndSectors.tsx